module.exports = __webpack_public_path__ + "img/car2_1.b910aa64.png";